module.exports = __webpack_public_path__ + "media/images/flags/32/Martinique-86e9883d6f56a10578b57acd0980bb63.png";